export const skillList = [
  {
    image: './assets/icons/companies/tools/aws.png',
    tooltip: 'Amazon Web Services (AWS)',
  },
  {
    image: './assets/icons/companies/tools/datadog.svg',
    tooltip: 'Datadog',
  },
  {
    image: './assets/icons/companies/tools/docker.png',
    tooltip: 'Docker',
  },
  {
    image: './assets/icons/companies/tools/gha.png',
    tooltip: 'GitHub Actions',
  },
  {
    image: './assets/icons/companies/tools/go.png',
    tooltip: 'Go (Golang)',
  },
  {
    image: './assets/icons/companies/tools/helm.png',
    tooltip: 'Helm',
  },
  {
    image: './assets/icons/companies/tools/java.png',
    tooltip: 'Java',
  },
  {
    image: './assets/icons/companies/tools/jenkins.png',
    tooltip: 'Jenkins',
  },
  {
    image: './assets/icons/companies/tools/jest.jpg',
    tooltip: 'Jest',
  },
  {
    image: './assets/icons/companies/tools/junit.png',
    tooltip: 'JUnit',
  },
  {
    image: './assets/icons/companies/tools/kubernetes.png',
    tooltip: 'Kubernetes',
  },
  {
    image: './assets/icons/companies/tools/mysql.png',
    tooltip: 'MySQL',
  },
  {
    image: './assets/icons/companies/tools/python.png',
    tooltip: 'Python',
  },
  {
    image: './assets/icons/companies/tools/react.png',
    tooltip: 'React',
  },
  {
    image: './assets/icons/companies/tools/springboot.png',
    tooltip: 'Spring Boot',
  },
  {
    image: './assets/icons/companies/tools/terraform.png',
    tooltip: 'Terraform',
  },
  {
    image: './assets/icons/companies/tools/typescript.png',
    tooltip: 'TypeScript',
  },
  {
    image: './assets/icons/companies/tools/c_programming.png',
    tooltip: 'C Programming',
  },
  {
    image: './assets/icons/companies/tools/networking.png',
    tooltip: 'Networking',
  },
];
